module.exports = __webpack_public_path__ + "img/icn-korean.7d849000.svg";